import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * The undo "before" snapshot for the crop gesture in progress: kept once captured, otherwise taken
 * from `cropShapeData` on the gesture's first tick (and only for the shape being cropped).
 */
export function resolveCropGestureBefore(
  gestureBefore: ShapeData | null,
  cropShapeData: ShapeData | null,
  shapeId: string
): ShapeData | null {
  if (!gestureBefore && cropShapeData?.id === shapeId) return cropShapeData

  return gestureBefore
}

/**
 * The undo "before" snapshot a crop commit records: the gesture's captured snapshot when it is for
 * this shape, else — for a one-shot edit with no drag phase (a flip) — the current `cropShapeData`
 * while this shape is the one being cropped, else nothing to commit against.
 */
export function resolveCropCommitBefore(
  gestureBefore: ShapeData | null,
  cropOriginalShape: ShapeData | null,
  cropShapeData: ShapeData | null,
  shapeId: string
): ShapeData | null {
  if (gestureBefore?.id === shapeId) return gestureBefore

  return cropOriginalShape?.id === shapeId ? cropShapeData : null
}
